export default "__VITE_ASSET__Bjm4lmKK__"